module.exports = __webpack_public_path__ + "img/Amriya1.2efef409.jpg";